import type { ApiError } from '@shared/types';

/**
 * Normalize any HTTP error response into a consistent ApiError shape.
 */
export async function normalizeError(response: Response): Promise<ApiError> {
  const correlationId =
    response.headers.get('x-correlation-id') ?? crypto.randomUUID();

  try {
    const body: unknown = await response.json();

    if (isApiError(body)) {
      return { ...body, correlationId: body.correlationId || correlationId };
    }

    return {
      code: `HTTP_${response.status}`,
      message:
        typeof body === 'object' && body !== null && 'message' in body
          ? String((body as { message: unknown }).message)
          : response.statusText,
      correlationId,
    };
  } catch {
    return {
      code: `HTTP_${response.status}`,
      message: response.statusText || 'Unknown error',
      correlationId,
    };
  }
}

function isApiError(value: unknown): value is ApiError {
  return (
    typeof value === 'object' &&
    value !== null &&
    'code' in value &&
    'message' in value
  );
}
